import type { SessionPermission } from '../permissions/session-permissions.ts';

// Each item names the permission its screen reads: every screen but Primeiros passos and the API
// documentation needs `common.read`, which a developer lacks, so a developer is shown those two.
export const navGroups = [
  {
    id: 'visao-geral',
    label: 'Visão geral',
    items: [
      { id: 'inicio', label: 'Início', to: '/inicio', permission: 'common.read' },
      { id: 'indicadores', label: 'Indicadores', to: '/indicadores', permission: 'common.read' },
    ],
  },
  {
    id: 'implantacao',
    label: 'Implantação',
    items: [
      { id: 'onboarding', label: 'Onboarding', to: '/onboarding', permission: 'common.read' },
    ],
  },
  {
    id: 'conformidade',
    label: 'Conformidade',
    items: [
      { id: 'conformidade', label: 'Conformidade', to: '/conformidade', permission: 'common.read' },
      {
        id: 'drift-regulatorio',
        label: 'Drift regulatório',
        to: '/drift-regulatorio',
        permission: 'common.read',
      },
      {
        id: 'testes-endpoint',
        label: 'Testes de endpoint',
        to: '/testes-endpoint',
        permission: 'common.read',
      },
      { id: 'dcr', label: 'DCR', to: '/dcr', permission: 'common.read' },
    ],
  },
  {
    id: 'relatorios',
    label: 'Relatórios ao regulador',
    items: [
      { id: 'pcm', label: 'PCM', to: '/pcm', permission: 'common.read' },
      {
        id: 'relatorio-diretor',
        label: 'Relatório do Diretor',
        to: '/relatorio-diretor',
        permission: 'common.read',
      },
    ],
  },
  {
    id: 'operacao',
    label: 'Operação',
    items: [
      { id: 'receptora', label: 'Receptora', to: '/receptora', permission: 'common.read' },
      {
        id: 'monitoramento',
        label: 'Monitoramento',
        to: '/monitoramento',
        permission: 'common.read',
      },
      { id: 'operacoes', label: 'Operações', to: '/operacoes', permission: 'common.read' },
    ],
  },
  {
    id: 'developer',
    label: 'Developer',
    items: [
      {
        id: 'primeiros-passos',
        label: 'Primeiros passos',
        to: '/primeiros-passos',
        permission: 'docs.read',
      },
      { id: 'aplicacoes', label: 'Aplicações', to: '/aplicacoes', permission: 'common.read' },
      {
        id: 'documentacao',
        label: 'Documentação das APIs',
        to: '/documentacao',
        permission: 'docs.read',
      },
    ],
  },
  {
    id: 'acesso',
    label: 'Acesso',
    items: [{ id: 'usuarios', label: 'Usuários', to: '/usuarios', permission: 'common.read' }],
  },
] as const satisfies readonly {
  readonly id: string;
  readonly label: string;
  readonly items: readonly {
    readonly id: string;
    readonly label: string;
    readonly to: string;
    readonly permission: SessionPermission;
  }[];
}[];

export type NavGroup = (typeof navGroups)[number];
export type NavItem = NavGroup['items'][number];

export const navItems = navGroups.flatMap((group): readonly NavItem[] => group.items);

/** The screen a session lacking `common.read` (a developer) is sent to. */
export const DEVELOPER_HOME_PATH = '/primeiros-passos';

/** The roots a session lacking `common.read` (a developer) reads: those needing `docs.read`. */
export const DEVELOPER_PATHS: readonly string[] = navItems
  .filter((item: NavItem) => item.permission === 'docs.read')
  .map((item) => item.to);

/** The groups whose items `grants` lets the session read, each with those items only. */
export const navGroupsFor = (
  grants: (permission: SessionPermission) => boolean,
): readonly { readonly group: NavGroup; readonly items: readonly NavItem[] }[] =>
  navGroups
    .map((group) => ({
      group,
      items: group.items.filter((item: NavItem) => grants(item.permission)),
    }))
    .filter(({ items }) => items.length > 0);
